module.exports = __webpack_public_path__ + "img/case-logo-29.7a5cd632.png";